import DataAccess from './constants';
import { genfunction } from '../helpers';

let path = 'IDME/UserData?token='

export const apiIDMeUserData = (idmeObj) => {

    var h = new Headers();
    h.append('Content-Type', 'application/json');

    let url = DataAccess.apiUrl + path + idmeObj.token;

    var myInit = { method: 'GET' };

    const req = new Request(url.replace("v3/", ""), myInit);

    return fetch(req);
}